<h5
    class="card-title selenium-card-title"
    [ngClass]="['rows-' + rows]"
    [ngStyle]="{ height: height ? height + 'px' : 'auto' }"
>
    <ng-content></ng-content>
</h5>
